import React from "react";

export const DescriptionPanel = ({ children, title }) => {
  return (
    <div className="panel panel-default">
      <div className={`panel-heading gln_contacthead `}>{title}</div>
      <div className="panel-body gln_contactlesspad">
        { children }
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Panel/DescriptionPanel.js